import React, { memo } from "react";
import { withEmptyCheck } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import { formatTimestamp } from "../../../../utils/date.js";
import "react-intl";
import { renderValueWithTooltip } from "./GridCellWithTooltip.js";
const DateCellFormatter = memo(({ value }) => {
  return renderValueWithTooltip(formatTimestamp(value, "date-time"));
});
const DateCell = withEmptyCheck(({ value }) => {
  return /* @__PURE__ */ React.createElement(DateCellFormatter, { value });
});
const renderDateCell = (params) => {
  const value = params.value;
  return /* @__PURE__ */ React.createElement(DateCell, { value });
};
export {
  DateCell,
  renderDateCell
};
//# sourceMappingURL=DateCell.js.map
